<template>
<div class="home-contact">
    <ElementsLineStars/>
    <div class="container" v-show="content">
        <h2>{{ content.titre }}</h2>
    <div class="w-full md:w-2/3 lg:w-1/2 mx-auto" v-html="content.contenu"></div>
    <div class="d-flex  jcc aic home-contact__btns">
        <CustomButton label="Envoyer un mail" to="mailto:paulinefuchs@hotmail.fr"/>
        <CustomButton label="Prendre un rendez-vous" target="_blank" to="https://tidycal.com/paulinefuchs/30-minute-meeting"/>
    </div>

    <FormContact/>
    </div>
</div>
</template>
<script setup lang='ts'>
import type { Contact } from '~/types/options';
import CustomButton from '../elements/CustomButton.vue';

defineProps<{
    content:Contact
}>()

</script>

<style lang="scss">
    .home-contact{
        position: relative;
p        h2{
            margin-bottom: 50px;
        }
        p{
            color: $text;
            font-weight: 600;
            text-align: center;
        }
        &__btns{
            margin: 40px 0;
            gap: 40px;
            @media screen and (max-width:600px) {
                flex-direction: column;
                gap: 20px;
            }
        }
    }
</style>